import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m14.633 4.353-.946-.94.946-.94a.67.67 0 1 0-.946-.946L6.66 8.553a3.333 3.333 0 1 0 .947.947l3.253-3.26.94.947a.67.67 0 0 0 .473.193.666.666 0 0 0 .474-1.14l-.947-.907.947-.946.94.946a.67.67 0 0 0 .473.194.67.67 0 0 0 .473-.194.666.666 0 0 0 0-.98m-9.806 8.98a2 2 0 1 1 0-4 2 2 0 0 1 0 4"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })